"use client";
import React from "react";
import { Button } from "../Button";
import headerLink from "@/configs/headerLink";
import footerSubLink from "@/configs/footerSubLink";

export default function MenuPage() {
  return (
    <section className=" animate-fade-in lg:hidden mobile-menu z-40 w-full dark:bg-dark-surface0 bg-surface0 fixed bottom-0 left-0">
      <div className="container">
        <div className=" flex gap-4 mt-8">
          <a className="flex-1" href="https://accounts.arvancloud.ir/register?lang=en">
            <Button className=" w-full h-12" variant="primary">
              Register
            </Button>
          </a>
          <a className="flex-1" href="https://accounts.arvancloud.ir/login?lang=en">
            <Button className=" w-full h-12" variant="outline">
              Login
            </Button>
          </a>
        </div>
        <div className=" mt-1 flex flex-col">
          {headerLink.map(({ title, to }) => (
            <a
              className=" w-full text-base font-semibold dark:text-dark-neutral-default text-neutral-default py-[30px] border-b dark:border-dark-br-low border-br-low"
              key={title}
              href={to}
              target="blank"
            >
              {title}
            </a>
          ))}
        </div>
        <div className=" flex flex-col gap-5 mt-5">
          {footerSubLink.map(({ title, link }) => (
            <a
              key={"title" + " menu"}
              className=" text-sm dark:text-dark-neutral-medium text-neutral-medium font-medium py-2 w-full"
              href={link}
              target="blank"
            >
              {title}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
